import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import EventsCloneForm from './EventsCloneForm';

export default function EventsClone(props) {
    return <EventsCloneForm eventsListUrl={eventsListUrl} eventCloneUrl={eventCloneUrl} redirectUrl={redirectUrl} />;
}

if (document.getElementById('eventsClone')) {
    var rootEl = document.getElementById('eventsClone');
    ReactDOM.render(
        <App>
            <EventsClone />
        </App>,
        rootEl,
    );
}
